import React from "react";
import { Link } from "react-router-dom";

const Footer = () => {
  return (
    <footer className="bg-slate-950 border-t border-slate-800 py-12 px-4">
      <div className="max-w-7xl mx-auto">
        <div className="flex flex-col md:flex-row items-center justify-between gap-8">
          {/* Logo and Creator Credit */}
          <div className="text-center md:text-left">
            <Link to="/" className="flex items-center gap-2 justify-center md:justify-start mb-3">
              <div className="w-8 h-8 bg-gradient-to-br from-emerald-400 to-emerald-600 rounded-lg flex items-center justify-center">
                <span className="text-white font-bold text-sm">L</span>
              </div>
              <span className="text-xl font-bold text-white">
                Loca<span className="text-emerald-400">Leap</span>
              </span>
            </Link>
            <p className="text-slate-500 text-sm">
              AI-powered brand strategy for local businesses.
            </p>
            <p className="text-slate-600 text-xs mt-2">
              Built by{" "}
              <a 
                href="http://vswagency.com" 
                className="text-emerald-500 hover:text-emerald-400"
                target="_blank"
                rel="noopener noreferrer"
              >
                VSW Agency / Merge Publishing
              </a>
            </p>
          </div>

          {/* Links */}
          <div className="flex flex-wrap items-center justify-center gap-6">
            <Link 
              to="/create" 
              className="text-slate-400 hover:text-emerald-400 text-sm transition-colors"
            >
              Get Started
            </Link>
            <Link 
              to="/privacy" 
              className="text-slate-400 hover:text-emerald-400 text-sm transition-colors"
            >
              Privacy Policy
            </Link>
            <Link 
              to="/terms" 
              className="text-slate-400 hover:text-emerald-400 text-sm transition-colors"
            >
              Terms of Service
            </Link>
            <a 
              href="mailto:don@vswagency.com" 
              className="text-slate-400 hover:text-emerald-400 text-sm transition-colors"
            >
              Contact
            </a>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="mt-8 pt-8 border-t border-slate-800 text-center">
          <p className="text-slate-500 text-sm">
            © {new Date().getFullYear()} LocaLeap. All rights reserved.
          </p>
          <p className="text-slate-600 text-xs mt-2">
            Currently in Beta — Free for a limited time!
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
